import { ErrorLogType } from 'types/error-log';

type ErrorLogErrorViewProps = {
  log: ErrorLogType;
};

export default function ErrorLogErrorView({ log }: ErrorLogErrorViewProps) {
  const isManualReport = log.errorType === 'manualReport';

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col gap-1'>
        <div className='text-xs font-semibold uppercase tracking-wide text-gray-500'>
          {isManualReport ? 'Subject' : 'Message'}
        </div>
        <div className='whitespace-pre-wrap break-words text-base font-medium text-gray-900'>
          {log.errorMessage}
        </div>
      </div>
      {log.explanation && (
        <div className='flex flex-col gap-1'>
          <div className='text-xs font-semibold uppercase tracking-wide text-gray-500'>
            Explanation
          </div>
          <div className='whitespace-pre-wrap break-words rounded-md border border-gray-200 bg-white p-3 text-sm text-gray-800'>
            {isManualReport ? `"${log.explanation}"` : log.explanation}
          </div>
        </div>
      )}
      <div className='flex flex-col gap-1'>
        <div className='text-xs font-semibold uppercase tracking-wide text-gray-500'>
          Stack
        </div>
        {log.errorStack ? (
          <pre className='overflow-auto whitespace-pre-wrap break-words rounded-md bg-gray-900 p-3 text-xs leading-5 text-gray-100'>
            {log.errorStack}
          </pre>
        ) : (
          <div className='text-sm text-gray-400'>No stack trace recorded.</div>
        )}
      </div>
    </div>
  );
}
